module.exports = __webpack_public_path__ + "static/media/institute-12-min.ed28b8ed.webp";